const ESCAPE_MAP = {
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#x27;',
    '"': '&quot;',
};
const UNESCAPE_MAP = {
    '&lt;': '<',
    '&gt;': '>',
    '&#x27;': "'",
    '&quot;': '"',
};
export function fullEscapeHTML(str) {
    return str.replace(/[<>'"]/gm, (ch) => ESCAPE_MAP[ch]);
}
export function fullUnescapeHTML(str) {
    return str.replace(/&lt;|&gt;|&#x27;|&quot;/gm, (entity) => UNESCAPE_MAP[entity]);
}
export function escapeQuotes(str) {
    return str.replace(/['"]/g, (ch) => ESCAPE_MAP[ch]);
}
